/* eslint-disable key-spacing */
import { hsl } from '../../../utils/svgs'

export default {
    fill: {
        sclera: hsl(216, 16, 88),
        pupil: hsl(0, 0, 0, 0.5),
        irisBrown: hsl(42, 18, 43),
        irisDarkBrown: hsl(36, 17, 40),
        gum: hsl(6, 37, 63),
        lipFemaleMedium: hsl(1, 27, 50, 0.5),
        lipFemaleMedium__noStroke: hsl(1, 27, 50, 0.5),
        lipFemaleBrown: hsl(2, 24, 43, 0.52),
        lipFemaleBrown__noStroke: hsl(2, 24, 43, 0.52),
        lipMaleMedium__noStroke: hsl(1, 17, 54, 0.4),
        lipMaleDark__noStroke: hsl(2, 15, 41, 0.45),
        teeth: hsl(40, 17, 82),
        tongue: hsl(350, 26, 63),
        mouthInner: hsl(4, 21, 39),

        skinEastAsian: hsl(29, 45, 68),
        skinLatino: hsl(24, 40, 59),
        skinIndian: hsl(21, 33, 52),
        skinBlack: hsl(29, 31, 48),

        eyebrowDarkBrown: hsl(19, 17, 25),
        eyebrowBlack: hsl(26, 7, 25),
        hairBlack: hsl(26, 7, 25),
        hairBlackDark: hsl(26, 7, 22),

        nippleEastAsian: hsl(16, 26, 49),
    },
}
